const {KitModule, registerModule} = window;

class PersonList extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindObservers();
  }

  bindObservers() {
    const options = {
      root: this.$navList,
      rootMargin: '0px',
      threshold: 1.0,
    };

    this.observer = new IntersectionObserver(this.observeNavList.bind(this), options);
    this.$navItems?.forEach(($navItem) => {
      this.observer.observe($navItem);
    });
  }

  observeNavList(entries) {
    entries.forEach((entry) => {
      const visibleNodesIndex = this.visibleNodes.indexOf(entry.target);

      if (entry.isIntersecting && visibleNodesIndex === -1) {
        this.visibleNodes.push(entry.target);
      } else if (!entry.isIntersecting && visibleNodesIndex > -1) {
        this.visibleNodes.splice(visibleNodesIndex, 1);
      }
    });

    this.isOverflowedLeft = !this.visibleNodes.includes(this.$navItems[0]);
    this.isOverflowedRight = !this.visibleNodes.includes(this.$navItems[this.$navItems.length - 1]);

    this.render();
  }

  render() {
    this.$navWrapper.dataset.isOverflowedLeft = this.isOverflowedLeft;
    this.$navWrapper.dataset.isOverflowedRight = this.isOverflowedRight;
  }

  setVars() {
    this.isOverflowedLeft = false;
    this.isOverflowedRight = false;
    this.visibleNodes = [];
  }

  unmount() {
    // ...
  }
}

registerModule('PersonList', PersonList);
